import { FC } from 'react';

import { SearchIcon, XIcon } from '@heroicons/react/outline';

export interface CouponSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

/**
 * 쿠폰 정산 화면 공용 통합 검색 인풋 — 돋보기 아이콘 + 지우기 버튼.
 * 미정산 상세·정산완료 상세·쿠폰 추가 피커 세 모달이 같은 마크업을 쓴다.
 * 검색은 표시 필터일 뿐이라는 규칙(포함/제외·집행·합계는 전체 목록 기준)은 호출부 책임.
 */
export const CouponSearchInput: FC<CouponSearchInputProps> = ({
  value,
  onChange,
  placeholder = '쿠폰번호·수령자·구매자·연락처 검색',
}) => (
  <div className="relative">
    <SearchIcon className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-72 rounded-lg border border-gray-300 py-1.5 pl-8 pr-8 text-sm focus:border-indigo-500 focus:outline-none"
    />
    {value && (
      <button
        onClick={() => onChange('')}
        className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full p-0.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
        aria-label="검색어 지우기"
      >
        <XIcon className="h-3.5 w-3.5" />
      </button>
    )}
  </div>
);
